import VueRouter from "vue-router";
import PageNormal from "components/page-normal";
import pageDetail from "components/page-detail";
import PageImg from "components/page-img";
import PageTopic from "components/page-topic2";
import PageLive from "components/page-live2";
// import PageOneComment from 'components/page-one-comment'
import PageAskDetail from "components/page-ask-detail";
import PageAskTopic from "components/page-ask-topic";
import PagePaper from "components/page-paper";
import PageJinGuan from "components/page-jinguan";
import PageFilm from "components/film";
import Theme from "components/page-theme"//话题
import pageGovernmentDetail from "components/page-government"  //拍吧-问政
import page24Hours from "components/page-24hours" 
// import test from 'components/test'

const router = new VueRouter({
  base: '/h5',
  mode: 'history',
  routes: [
    // {path: '/test', component: test},
    // {path: '/normal/:sysCode/:categoryId/:id', component: PageNormal},
    // {path: '/oneComment/:id', component: PageOneComment},
    // {path: '/ask/detail/:id', component: PageAskDetail},
    // {path: '/ask/topic/:id', component: PageAskTopic},
    { path: "/normal/:sysCode/:categoryId/:id", component: PageNormal },
    { path: "/detail/:type/:id", name:"Detail",component: pageDetail },
    { path: "/img/:sysCode/:categoryId/:id", component: PageImg },
    { path: "/topic/:id", component: PageTopic }, //专题页
    { path: "/live/:id", component: PageLive }, //直播
    { path: "/paper/:sysCode/:id/:date", component: PagePaper }, //读报
    { path: "/film/:id", component: PageFilm }, //小视频
    {
      path:"/theme/:id",//话题
      component:Theme
    },
    { 
      path: "/local/:id", 
      name: 'Local',
      component: PageJinGuan 
    }, //锦观号

    { 
      path: "/government/detail/:id", // 拍吧
      name:"GovernmentDetail",
      component: pageGovernmentDetail
    },
    { 
      path: "/24hours", // 24小时
      name:"Hours",
      component: page24Hours
    },
    
  ]
});
router.beforeEach((to, from, next) => {
  const { hash, fullPath, path, query } = to
  console.log(router.options.base, 'router')
  console.log(window.location, 'to')
  // alert("b1_"+hash)
  if (hash && hash.indexOf('#/') >= 0){
    const arr = Object.keys(query).map((key) => `${key}=${query[key]}`);
    const hashUrl = hash.replace('#/','')
    const url = arr.length ? `${router.options.base}${path}${hashUrl}?${arr.join('&')}` : `${router.options.base}${path}${hashUrl}`;
    // console.log(to,'to', url)
    // alert("b2_"+url)
    window.location.href = url
    
    // next({ 
    //   ...to,
    //   path: hash.replace('#',''),
    //   replace: true,
    // })
  }
  console.log('beforeEach',__dirname)
  next()
})
export default router;



// WEBPACK FOOTER //
// ./src/router.js